import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2426447c = () => interopDefault(import('../../../pages/contact-opnemen/index.vue' /* webpackChunkName: "pages/contact-opnemen/index" */))
const _73843fa3 = () => interopDefault(import('../../../pages/contact-opnemen-bedrijf/index.vue' /* webpackChunkName: "pages/contact-opnemen-bedrijf/index" */))
const _717d8718 = () => interopDefault(import('../../../pages/informatie-over-cv-installateurs/index.vue' /* webpackChunkName: "pages/informatie-over-cv-installateurs/index" */))
const _0b93b838 = () => interopDefault(import('../../../pages/contact-opnemen-bedrijf/bevestigd.vue' /* webpackChunkName: "pages/contact-opnemen-bedrijf/bevestigd" */))
const _63afd786 = () => interopDefault(import('../../../pages/contact-opnemen/bevestigd.vue' /* webpackChunkName: "pages/contact-opnemen/bevestigd" */))
const _7c69fa5e = () => interopDefault(import('../../../pages/offertes-aanvragen/aanvraag-afgerond.vue' /* webpackChunkName: "pages/offertes-aanvragen/aanvraag-afgerond" */))
const _2517b3e6 = () => interopDefault(import('../../../pages/offertes-aanvragen/je-gegevens.vue' /* webpackChunkName: "pages/offertes-aanvragen/je-gegevens" */))
const _089c4b6d = () => interopDefault(import('../../../pages/offertes-aanvragen/start.vue' /* webpackChunkName: "pages/offertes-aanvragen/start" */))
const _f2a5bcca = () => interopDefault(import('../../../pages/offertes-aanvragen/type-opdracht.vue' /* webpackChunkName: "pages/offertes-aanvragen/type-opdracht" */))
const _c8f0ab8c = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const _861e7d2c = () => interopDefault(import('../../../../../shared/all/page/privacy/PrivacyPage.vue' /* webpackChunkName: "" */))
const _1c6fcb10 = () => interopDefault(import('../../../../../shared/all/page/cookies/CookiesPage.vue' /* webpackChunkName: "" */))
const _0b412bf8 = () => interopDefault(import('../../../../../shared/all/page/termsAndConditions/TermsAndConditionsPage.nl.vue' /* webpackChunkName: "" */))
const _2b1ecb13 = () => interopDefault(import('../../../../../shared/all/themes/blueflow/page/ErrorPage.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/contact-opnemen",
    component: _2426447c,
    name: "contact-opnemen"
  }, {
    path: "/contact-opnemen-bedrijf",
    component: _73843fa3,
    name: "contact-opnemen-bedrijf"
  }, {
    path: "/informatie-over-cv-installateurs",
    component: _717d8718,
    name: "informatie-over-cv-installateurs"
  }, {
    path: "/contact-opnemen-bedrijf/bevestigd",
    component: _0b93b838,
    name: "contact-opnemen-bedrijf-bevestigd"
  }, {
    path: "/contact-opnemen/bevestigd",
    component: _63afd786,
    name: "contact-opnemen-bevestigd"
  }, {
    path: "/offertes-aanvragen/aanvraag-afgerond",
    component: _7c69fa5e,
    name: "offertes-aanvragen-aanvraag-afgerond"
  }, {
    path: "/offertes-aanvragen/je-gegevens",
    component: _2517b3e6,
    name: "offertes-aanvragen-je-gegevens"
  }, {
    path: "/offertes-aanvragen/start",
    component: _089c4b6d,
    name: "offertes-aanvragen-start"
  }, {
    path: "/offertes-aanvragen/type-opdracht",
    component: _f2a5bcca,
    name: "offertes-aanvragen-type-opdracht"
  }, {
    path: "/",
    component: _c8f0ab8c,
    name: "index"
  }, {
    path: "*",
    redirect: {"path":"/"}
  }, {
    path: "/privacy",
    component: _861e7d2c,
    name: "privacy"
  }, {
    path: "/cookies",
    component: _1c6fcb10,
    name: "cookies"
  }, {
    path: "/algemene-voorwaarden",
    component: _0b412bf8,
    name: "algemene-voorwaarden"
  }, {
    path: "/error",
    component: _2b1ecb13,
    name: "error"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
